<template>
  <dashboard-block
    :title="title"
    :caption="caption"
    :loading="loading"
    :missing="!block"
    :min-height="minHeight"
    skeleton="heading, text@2"
  >
    <v-row
      v-if="block"
      class="dashboard-today"
    >
      <v-col
        v-for="tile in tiles"
        :key="tile.title"
        cols="6"
        md="3"
      >
        <div class="text-caption text--secondary">
          {{ tile.title }}
        </div>
        <div class="d-flex align-baseline flex-wrap">
          <span
            class="dashboard-today__value me-2"
            :class="tile.isMissing ? 'dashboard-today__value--missing text--secondary' : 'text--primary font-weight-semibold'"
          >{{ tile.value }}</span>
          <span
            v-if="tile.note"
            class="text-caption text--secondary"
          >{{ tile.note }}</span>
        </div>

        <div class="dashboard-today__change text-caption">
          <template v-if="tile.change">
            <v-icon
              v-if="tile.change.direction"
              size="16"
              :color="toneColor(tile.change.tone)"
            >
              {{ tile.change.direction > 0 ? icons.mdiArrowUp : icons.mdiArrowDown }}
            </v-icon>
            <span
              class="font-weight-semibold"
              :class="toneClass(tile.change.tone)"
            >{{ tile.change.value }}</span> <span class="text--secondary">{{ tile.change.text }}</span>
          </template>
        </div>

        <v-tooltip
          v-if="tile.extra"
          bottom
          max-width="320"
        >
          <template #activator="{ on, attrs }">
            <span
              class="dashboard-today__extra text-caption text--secondary"
              v-bind="attrs"
              v-on="on"
            >{{ tile.extra.text }}</span>
          </template>
          <span>{{ tile.extra.tooltip }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </dashboard-block>
</template>

<script>
import { mdiArrowDown, mdiArrowUp } from '@mdi/js'
import DashboardBlock from '@/views/dashboard/dashboard-block'
import { todayTiles, toWeekdayDayString } from '@/helpers/dashboard'

export default {
  name: 'DashboardToday',
  components: { DashboardBlock },
  props: {
    block: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    icons: { mdiArrowDown, mdiArrowUp },
  }),
  computed: {
    title() {
      return this.block && this.block.date ? `Сегодня — ${toWeekdayDayString(this.block.date)}` : 'Сегодня'
    },
    caption() {
      const previous = this.block && this.block.previous

      if (!previous) return 'Сравнить не с чем: данных за тот же день неделю назад нет'

      return previous.date
        ? `Сравнение — к тому же времени неделю назад: ${toWeekdayDayString(previous.date)}`
        : 'Сравнение — к тому же времени неделю назад'
    },
    tiles() {
      return this.block ? todayTiles(this.block) : []
    },

    minHeight() {
      return this.$vuetify.breakpoint.mdAndUp ? 146 : 280
    },
  },
  methods: {
    toneColor(tone) {
      return { good: 'success', bad: 'error' }[tone]
    },
    toneClass(tone) {
      return { good: 'success--text', bad: 'error--text', flat: 'text--secondary' }[tone]
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-today {
  .dashboard-today__value {
    font-size: 1.5rem;
    line-height: 2rem;
    white-space: nowrap;
  }

  .dashboard-today__value--missing {
    font-size: 1rem;
  }

    .dashboard-today__change {
    min-height: 1.25rem;
  }

    .dashboard-today__extra {
    border-bottom: 1px dashed currentColor;
    cursor: help;
  }
}
</style>
